<template>
  <main>
    <cms-section v-if="eSpots?.[0]" class="px-6" :section="eSpots[0]" />
    <vf-tabs
      v-model:active="activeTab"
      class="my-4 px-6"
      class-trigger-active="b-black"
      :tabs="tabs.map(({ title }) => title)"
      variant="left"
      @update:active="handleUpdateActive"
    />
    <p v-if="!pending && !data?.productSets" class="my-14 px-6 text-center text-sm">
      {{ $t.noResults }}
    </p>
    <template v-else>
      <template v-for="(productSet, i) in data?.productSets!" :key="productSet.productSetId">
        <base-lazy-load>
          <template #pending>
            <div class="mt-4 gap-4 md:flex md:px-6" :class="{ 'flex-row-reverse': i % 2 }">
              <div class="aspect-square skeleton md:w-1/2" />
              <div class="grid mt-6 aspect-square gap-2 <md:grid-flow-col md:cols-3 md:w-1/2 md:px-6">
                <product-card-skeleton
                  v-for="j in 2"
                  :key="`skeleton-${j}`"
                />
              </div>
            </div>
          </template>
          <template #default>
            <transition appear name="fade-out">
              <product-shop-the-look-section
                class="mb-4 md:px-6"
                :class="{ 'flex-row-reverse': i % 2 }"
                :product-set
              />
            </transition>
          </template>
        </base-lazy-load>
      </template>
    </template>
    <cms-section v-if="eSpots?.[1]" class="px-6" lazy-media :section="eSpots[1]" />
  </main>
</template>

<script lang="ts" setup>
const { products } = useApi()
const { $t } = useNuxtApp()
const { plp: { defaultSort } } = useAppConfig().pages

const tabs = [
  { title: $t.all, category: 'all', cgid: 'looks' },
  { title: $t.men, category: 'men', cgid: 'men-looks' },
  { title: $t.women, category: 'women', cgid: 'women-looks' }
]

const category = useRouteQuery('category', tabs[0].category)
const query = reactive({ cgid: tabs[0].cgid, context: 'product_set', count: 100, sort: defaultSort, start: 0 })

const activeTab = computed(() =>
  String(Math.max(tabs.findIndex((tab) => tab.category === category.value.toLowerCase()), 0))
)

watchEffect(() => {
  query.cgid = tabs[activeTab.value].cgid
})

const eSpots = (await useCms().getSections.generic('get-the-look')).data.value?.content?.sections

const { data, pending, error } = await products.catalog(query, { key: query.cgid })

if (error.value)
  throw createError({ statusCode: error.value.statusCode! >= 500 ? 500 : 404 })

const handleUpdateActive = (active: string) => {
  if (tabs[active]) {
    query.cgid = tabs[active].cgid
    category.value = tabs[active].category
  }
}
</script>
